import { FC } from 'react';
import { RuntimeConfigurationValueType } from '../../../types/enums/runtime-configuration-enums';
import { normalizeValueType } from '../runtimeConfiguration.helpers';

type Props = {
    valueType: string;
    label: string;
};

const TYPE_CLASS: Record<string, string> = {
    [RuntimeConfigurationValueType.String]: 'rc-type-badge--string',
    [RuntimeConfigurationValueType.Boolean]: 'rc-type-badge--boolean',
    [RuntimeConfigurationValueType.Json]: 'rc-type-badge--json',
    Integer: 'rc-type-badge--string',
    Decimal: 'rc-type-badge--string',
    Date: 'rc-type-badge--string',
    DateTime: 'rc-type-badge--string',
    StringList: 'rc-type-badge--string',
    IntList: 'rc-type-badge--string',
};

export const RuntimeConfigurationTypeBadge: FC<Props> = ({ valueType, label }) => {
    const normalizedType = normalizeValueType(valueType);
    return (
        <span className={`rc-type-badge ${TYPE_CLASS[normalizedType] || 'rc-type-badge--string'}`}>{label}</span>
    );
};
